import React, { useEffect } from "react";
import { useOutletContext } from "react-router-dom";
import "../css/Page__Styles.css";
import "../css/Page__ProjectDetails.css";
import Footer from "../components/Footer.jsx";

const ProjectDetails = ({ project }) => {
  // Obtenemos la función enviada a través de Outlet desde Layout.jsx
  const { setHeaderLinksColor } = useOutletContext();

  // Título de la pestaña
  useEffect(() => {
    if (project?.title) {
      document.title = `Eme / ${project.title}`;
    }
  }, [project?.title]);

  // Color dinámico para los enlaces y el logo del header
  useEffect(() => {
    if (project && project["font-color-index"] && setHeaderLinksColor) {
      setHeaderLinksColor(project["font-color-index"]);
    }

    // Al desmontar el componente (salir del proyecto), vuelve al color base
    return () => {
      if (setHeaderLinksColor) {
        setHeaderLinksColor("#000000");
      }
    };
  }, [project, setHeaderLinksColor]);

  return (
    <div>
      <div className="project__page">
        <section
          className="intro"
          style={{
            backgroundImage: `url(${project.introImage})`,
            backgroundSize: "cover",
            backgroundPosition: "center center",
          }}
        >
          <div
            className="cover"
            style={{
              backgroundImage: `url(${project.cover})`,
            }}
          ></div>
        </section>

        <section className="main-content">
          <h2>{project.introText}</h2>

          <div className="project_gallery">
            {project.gallery.map((item, index) => (
              <div
                key={index}
                className={`gallery_item gallery_item--${item.layout}`}
              >
                {item.type === "video" ? (
                  <video
                    className="gallery_media"
                    src={item.src}
                    autoPlay
                    muted
                    loop
                    playsInline
                    disablePictureInPicture
                    controls={false}
                    preload="none"
                    onClick={(e) => e.preventDefault()}
                  />
                ) : (
                  <img
                    className="gallery_media"
                    src={item.src}
                    alt={`${project.title} - imagen ${index + 1}`}
                    loading="lazy"
                  />
                )}
              </div>
            ))}
          </div>
        </section>

        <section className="credits">
          <p className="title">Fotografía</p>
          <p className="colabo">Sofía García</p>
        </section>
      </div>

      <Footer />
    </div>
  );
};

export default ProjectDetails;